/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityTokenListRequest = {
    sortField?: HumanityTokenListRequest.sortField;
    sortDirection?: HumanityTokenListRequest.sortDirection;
    tokenTypeList?: Array<'NA' | 'CA' | 'ERC20' | 'ERC721' | 'ERC1155'>;
    page?: number;
    size?: number;
};

export namespace HumanityTokenListRequest {

    export enum sortField {
        PRICE = 'PRICE',
        MARKET_CAP = 'MARKET_CAP',
        VOLUME = 'VOLUME',
        HOLDER = 'HOLDER',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

